import { FontWeight } from '@pasteltech/theme-provider'
import { memo } from 'react'
import ReactMarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import styled from 'styled-components'
import { DeepNullable, ScreenQuery } from '../../utilities'
import { StrapiSvg, StrapiSvgData } from '../strapi-svg'

const Background = styled.div`
  background-color: ${({ theme }) => theme.colors.container.high};
  background-image:
    url('/images/about-us-page-prize-section-left-background.png'),
    url('/images/about-us-page-prize-section-right-background.png');
  background-position: left, right;
  background-repeat: no-repeat, no-repeat;
`
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.sizes.spacings.xxxxxl}px 0px;
  gap: ${({ theme }) => theme.sizes.spacings.xxxxl}px;
`
const Title = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.primary.mainContrast};
  font-size: ${({ theme }) => theme.sizes.fontSize.heading2}px;
  font-weight: ${FontWeight.bold};
`
const PrizeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.sizes.spacings.xl}px;
  width: 100%;
`
const PrizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 calc(33.333% - ${({ theme }) => theme.sizes.spacings.xl}px);
  align-items: center;
  gap: ${({ theme }) => theme.sizes.spacings.xxl}px;
  ${ScreenQuery.mobile} {
    padding-bottom: ${({ theme }) => theme.sizes.spacings.xl}px;
    flex: 0 0 100%;
  }
  ${ScreenQuery.tablet} {
    padding-bottom: ${({ theme }) => theme.sizes.spacings.xl}px;
    flex: 0 0 100%;
  }
`
const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: ${({ theme }) => theme.sizes.spacings.lg}px;
  background: ${({ theme }) => theme.colors.container.lowest};
`
const PrizeName = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.primary.mainContrast};
  font-size: ${({ theme }) => theme.sizes.fontSize.title}px;
  font-weight: ${FontWeight.bold};
  p {
    margin: 0;
  }
`
const PrizeDescription = styled.div`
  color: ${({ theme }) => theme.colors.text.low};
  text-align: center;
`
const NameAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: ${({ theme }) => theme.sizes.spacings.sm}px;
`

type Prize = null | DeepNullable<{
  id: string
  // this is a markdown field for line break between multiple prize name
  name: string
  description: string
  icon: StrapiSvgData
}>
type Props = {
  data: Prize[]
  title: string
}
export const PrizeSection = memo(({ data, title }: Props) => {
  return (
    <Background>
      <Container>
        <Title>{title}</Title>
        <PrizeList>
          {data.map((prize) => {
            return (
              <PrizeContainer key={prize?.id}>
                <IconContainer>
                  <StrapiSvg strapiSvg={prize?.icon} />
                </IconContainer>
                <NameAndDescriptionContainer>
                  <PrizeName>
                    <ReactMarkDown rehypePlugins={[rehypeRaw]}>
                      {prize?.name}
                    </ReactMarkDown>
                  </PrizeName>
                  <PrizeDescription>{prize?.description}</PrizeDescription>
                </NameAndDescriptionContainer>
              </PrizeContainer>
            )
          })}
        </PrizeList>
      </Container>
    </Background>
  )
})

PrizeSection.displayName = 'PrizeSection'
